import { cn } from '../../lib/utils'

export const PhoneMockup = ({ children, className, tilt = 'none' }) => (
  <div className={cn(
    'relative mx-auto',
    tilt === 'left'  && '-rotate-3',
    tilt === 'right' && 'rotate-3',
    className,
  )}>
    {/* Phone shell */}
    <div className="relative w-[220px] sm:w-[260px] bg-[#1a1a2e] rounded-[36px] shadow-2xl shadow-black/40 border-[6px] border-[#1a1a2e] overflow-hidden">
      {/* Status bar notch */}
      <div className="absolute top-0 inset-x-0 h-7 bg-[#1a1a2e] z-10 flex items-center justify-center">
        <div className="w-20 h-4 bg-[#0d0d1a] rounded-full" />
      </div>
      {/* Screen */}
      <div className="bg-[#f7f5f2] min-h-[420px] sm:min-h-[500px] pt-7 overflow-hidden">
        {children}
      </div>
    </div>
    {/* Glow */}
    <div className="absolute inset-0 rounded-[36px] bg-primary/10 blur-2xl -z-10 scale-110" />
  </div>
)
